export default ['bmi','sys/dias','fbs/fpg','hba1c','bun','creatinine','egfr','chol','tg','hdl','ldl','uric','sgot','sgpt','alp','lung','waistline','spo2', 'pulse','temp'];
